/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 08:59
 */
const EventEmitter = require('events');

class Column extends EventEmitter {

  constructor({ $root, level = 0 }) {
    super();
    this.$root = $root;
    this.root = $root.get(0);
    this.rootEl = this.root;
    this.level = level;
  }

  init() {
    return this;
  }

  startSorting() {
    return this;
  }

  stopSorting() {
    return this;
  }

  emitBusyState(isBusy) {
    if (isBusy) {
      this.emit('busy');
    } else {
      this.emit('idle');
    }
  }

  label() {
    const value = this.$root.find('label').first().html();
    return value.split('<')[0].trim();
  }

}

export default Column;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/Column.js